document.addEventListener('DOMContentLoaded', function() {
  // Initialize all accordions on the page
  document.querySelectorAll('.app-accordion__container').forEach(function(accordion) {
    const defaultOpen = accordion.dataset.defaultOpen;
    const toggles = accordion.querySelectorAll('.navigation-mobile-accordion__toggle');
    
    // Initial setup for default open item
    if (defaultOpen) {
      // Find the toggle button with text matching defaultOpen
      toggles.forEach(function(toggle) {
        if (toggle.textContent.trim() === defaultOpen && toggle.hasAttribute('aria-controls')) {
          const submenuId = toggle.getAttribute('aria-controls');
          const submenu = document.getElementById(submenuId);
          
          // Set it as expanded
          toggle.setAttribute('aria-expanded', 'true');
          if (submenu) {
            submenu.style.height = 'auto';
            submenu.removeAttribute('hidden');
          }
          toggle.closest('.navigation-mobile-accordion__item').classList.add('submenu-active');
        }
      });
    }
    
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        // Don't run this on the link-only toggles (those without aria-controls)
        if (!this.hasAttribute('aria-controls')) return;
        
        e.preventDefault();
        
        const submenuId = this.getAttribute('aria-controls');
        const submenu = document.getElementById(submenuId);
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // First close all other open submenus
        toggles.forEach(otherToggle => {
          // Skip if it's the current toggle or doesn't have controls
          if (otherToggle === toggle || !otherToggle.hasAttribute('aria-controls')) return;
          
          // If another toggle is expanded, close it
          if (otherToggle.getAttribute('aria-expanded') === 'true') {
            const otherId = otherToggle.getAttribute('aria-controls');
            const otherMenu = document.getElementById(otherId);
            
            // Close this menu
            otherToggle.setAttribute('aria-expanded', 'false');
            otherMenu.style.height = '0px';
            
            setTimeout(() => {
              otherMenu.setAttribute('hidden', '');
            }, 300);
            
            otherToggle.closest('.navigation-mobile-accordion__item').classList.remove('submenu-active');
          }
        });
        
        // Toggle expanded state for current toggle
        this.setAttribute('aria-expanded', !isExpanded);
        
        // Toggle submenu visibility
        if (isExpanded) {
          // Close menu
          submenu.style.height = `${submenu.scrollHeight}px`;
          
          // Force reflow
          submenu.offsetHeight;
          
          // Animate closed
          submenu.style.height = '0px';
          
          setTimeout(() => {
            submenu.setAttribute('hidden', '');
          }, 300);
          
          toggle.closest('.navigation-mobile-accordion__item').classList.remove('submenu-active');
        } else {
          // Open menu
          submenu.removeAttribute('hidden');
          submenu.style.height = '0px';
          
          // Force reflow
          submenu.offsetHeight;
          
          // Animate open
          submenu.style.height = `${submenu.scrollHeight}px`;
          toggle.closest('.navigation-mobile-accordion__item').classList.add('submenu-active');
          
          // Once animation completes, set height to auto to handle content changes
          setTimeout(() => {
            submenu.style.height = 'auto';
          }, 300);
        }
      });
    });
  });
});